export class AzureAccount {
  Id: number;
  AccountName: string;
  SubscriptionId: string;
  Active: boolean;

  constructor() {
    this.Active = true;
  }
}

export class AzureAccountDisplay {
  Id: number;
  AccountName: string;
  SubscriptionId: string;
  RelatedNamespacesCount: number;
  RelatedEndpointsCount: number;
  Active: boolean;

  constructor() { }
}
